// from general.js
/* global isMobileView */

import {
    addDonateOptionsClose,
    populateDonateOptions,
    toggleDonateOptions,
} from '../../donateBar/floatingDonateBar.js';


// for mobile donate bar
export function getDonateOptions() {
    // build widget based on giving to proposal
    $('#followEmailHolder').hide();
    if ($('#donateOptions').length === 0) {
        $('#donateBar').before('<div id="donateOptions"></div>');
    }
    if ($('#inspireForm').length > 0) {
        populateDonateOptions('inspireForm', 'amount');
    } else if ($('#quickDonate').length > 0) {
        populateDonateOptions('quickDonate', 'donationAmount');
        $('#donateOptions').prepend($('#quickDonate .mobile'));
    }

    if ($('#donateOptions .close').length === 0) addDonateOptionsClose();
    toggleDonateOptions();
}

$(window).on('orientationchange resize', function () {
    // Check for not focus bc Android considers focus on input a resize
    if (!$('input#amount').is(':focus')) {
        if (!isMobileView()) {
            $('#inspireForm').prependTo('#inspireFormDiv');
            $('.js-donate-holder').prepend($('#quickDonate'));
        } else if ($('#donateOptions').hasClass('on')) {
            toggleDonateOptions();
        }
    }
});
